export const toSlug = (value: string) =>
  value
    .toLowerCase()
    .trim()
    .replace(/\s{2,}/g, ' ')
    .replace(/\s/g, '-')
    .replace(/[^\w-]/g, '')
